// ----
import activateProduct from '../../../assets/gsma/activate-product.svg';
import dashboardArchitectureImage from '../../../assets/gsma/architecture_summary.png';
import dashboardBetaTestImage from '../../../assets/gsma/beta-test.svg';
import BGPattern from '../../../assets/gsma/bg-pattern.svg';
import dashboardEntitlementsHeader from '../../../assets/gsma/dashboard-entitlements-header.jpg';
import dontUseEntitlementServer from '../../../assets/gsma/dont-use-entitlement-server.svg';
import entitlementsGetStarted from '../../../assets/gsma/entitlements-get-started.png';
import entitlementsGetStarted2 from '../../../assets/gsma/entitlements-get-started-2.svg';
import dashboardGoLiveImage from '../../../assets/gsma/go-live.svg';
import dashboardIntro1 from '../../../assets/gsma/introduction-intro.svg';
import backgroundLoginImage from '../../../assets/gsma/login-background.png';
import logo from '../../../assets/gsma/logo.png';
import logoLight from '../../../assets/gsma/logo-light.png';
import logoMini from '../../../assets/gsma/logo-mini.png';
import dashboardPreRequisitesImage from '../../../assets/gsma/prerequisites.svg';
import dashboardProductionReadinessImage from '../../../assets/gsma/production-readiness.svg';
import useEntitlementServer from '../../../assets/gsma/use-entitlement-server.svg';
import { Config } from './types/brands';

export const gsmaConfig: Config = {
  context: 'gsma',
  assets: {
    activateProduct,
    backgroundLoginImage,
    dashboardEntitlementsHeader,
    dontUseEntitlementServer,
    entitlementsGetStarted,
    entitlementsGetStarted2,
    logoMini,
    logo,
    logoLight,
    useEntitlementServer,
    onboarding: {
      dashboardIntro1,
      architecture: dashboardArchitectureImage,
      prerequisites: dashboardPreRequisitesImage,
      productionReadiness: dashboardProductionReadinessImage,
      betaTest: dashboardBetaTestImage,
      goLive: dashboardGoLiveImage,
    },
    reviewBgPattern: BGPattern,
  },
  i18n: {
    variables: {
      companyName: 'GSMA',
      productName: 'GSMA Entitlements',
      productFullName: 'GSMA Entitlements',
      portalFullName: 'GSMA Entitlements Developer Portal',
      saasFullName: 'GSMA Entitlements as a Service',
      supportEmail: 'eshelpdesk@gsma.com',
      productionSupportEmail: 'eshelpdesk@gsma.com',
      productionSupportTickets: 'eshelpdesk@gsma.com',
      uesContractUrl: '',
    },
  },
  environments: {
    settings: {
      companyFlag: 'GSMA',
      sideMenuLogoHeight: '55px',
      sideMenuLogoPadding: '12px 0',
      termOfServiceUrl:
        'https://www.gsma.com/about-us/gsma-app-end-user-license-agreement-eula/',
      privacyPolicyURL: 'https://www.gsma.com/about-us/legal/privacy/',
      cookiesPolicyURL: 'https://www.gsma.com/about-us/legal/cookie-policy/',
      imprintUrl: undefined,
      poweredBy: undefined,
      menuLogoUrl:
        'https://www.gsma.com/solutions-and-impact/industry-services/network-services/gsma-entitlements/',
      widgetCSSUrl:
        'https://www.gsma.com/wp-content/themes/theme_gsma_2023/entitlements.css',
    },
  },
};
